const intial={
	message:"",
	a:localStorage.getItem("nikhil")?(JSON.parse(localStorage.getItem("nikhil"))):([{id:1,name:"demo1",email:"demo1@gmail.com"}]),
	ob:{id:0,name:"",email:''}
}
let reducer=function(state=intial,action){
		localStorage.setItem("nikhil",JSON.stringify(state.a))
	
	switch(action.type)
	{
		case "insert":
			return {
				...state,
				a:[...state.a,action.payload],
				message:"new student added"
			}
		case "delete":
			return {
				...state,
				a:state.a.filter(x=>x.id!==action.payload),
				message:"this student deleted"
			}
		case "edit":
			return {
				...state,
				ob:action.payload
			}
	case "input":
			return {
				...state,
				ob:{...state.ob,[action.payload.col]:action.payload.val}
			}
	case "update":
			return {
				...state,
				a:state.a.map(x=>x.id===state.ob.id?(state.ob):(x)),
				ob:{id:0,name:"",email:""},
				message:"this student updated"
			}
			
		default:
			return state

	}
}
export default reducer;